import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";

const CollaborateFormList = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/getCollaborateFormList");
    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        const list = response.data.data.reverse();
        setList(list);
        setLoading(false);
      })
      .catch((error) => {
        // alert("Something Went Wrong");
      });
  }, []);
  return (
    <>
      <MaterialTable
        title="Collaborate Form"
        columns={[
          {
            title: "Date",
            field: "date",
          },
          {
            title: "Time",
            field: "time",
          },

          {
            title: "Name",
            field: "name",
          },
          {
            title: "EmailId",
            field: "email",
          },

          {
            title: "Phone Number",
            field: "phoneNumber",
          },
          {
            title: "Country",
            field: "country",
          },
          {
            title: "Website",
            field: "website",
          },
          {
            title: "Company Name",
            field: "companyName",
          },

          { title: "Message", field: "message" },
        ]}
        data={list}
        options={{
          exportButton: {csv:true},
          actionsColumnIndex: -1,
        }}
      />
    </>
  );
};

export default CollaborateFormList;
